import React, {useState} from "react"
import {TextArea, ValidationButton} from "@irati/ui/src/FormItem"
import FormattedMessage from "@irati/utils/lang"
import {PointsRequest, PointsRequestStatus} from "@irati/types"
import Form from "@irati/ui/src/Form"
import Spacing from "@irati/ui/src/Spacing"
import styled from "styled-components"
import {useUpdateRequestPointsStatus} from "@irati/wallet/hooks/wallet"
import Flex from "@irati/ui/src/Flex"
import Button from "@irati/ui/src/Button"
import Error from "@irati/ui/src/Loading/Error"
import {Body, H2} from "@irati/ui/src/Typography"
import Icon, {IconTypes} from "@irati/ui/src/Icon"

interface Props {
  onCancel: () => void
  onDone: (pointsRequest: PointsRequest) => void
  uuid: string
  status: PointsRequestStatus
}

const StyledForm = styled(Form)`
  textarea {
    resize: vertical;
    min-height: 40px;
  }
`
const UpdateStatusRequestPointsForm = (props: Props) => {
  const {onDone, status, uuid, onCancel} = props
  const [updatePointsRequestStatus, {error, errorMsg, load}] = useUpdateRequestPointsStatus({
    onCompleted: (data) => onDone(data.updatePointsRequestStatus),
    update(cache, {data}) {
      if (!data) return
      cache.evict({id: cache.identify({__typename: "PointsRequest", uuid: data.uuid})})
      cache.modify({
        fields: {
          listPointsRequests(existingList = {}, {readField}) {
            const newResults = (existingList.results || []).filter((ref: any) => readField("uuid", ref) !== uuid)
            return {
              ...existingList,
              results: newResults,
              total: Math.max(0, (existingList.total || 1) - 1)
            }
          }
        }
      })
      cache.gc()
    }
  })
  const [responseMessage, setResponseMessage] = useState("")
  const sendRequest = () => {
    updatePointsRequestStatus({
      variables: {
        input: {
          status,
          uuid,
          responseMessage
        }
      }
    })
  }
  return (
    <StyledForm>
      <Spacing marginTop={3}>
        {status === PointsRequestStatus.StatusCancelled && (
          <Flex direction="column" justifyContent="center" alignItems="center" gap={2}>
            <Icon icon={IconTypes.rewardPoints} size={76} />
            <H2>
              <FormattedMessage id="wallet.reward.pointsRequest.modal.updateStatus.cancel.title" />
            </H2>
            <Body textAlign="center">
              <FormattedMessage id="wallet.reward.pointsRequest.modal.updateStatus.cancel.text" />
            </Body>
          </Flex>
        )}
        {(status === PointsRequestStatus.StatusApproved || status === PointsRequestStatus.StatusDeclined) && (
          <TextArea
            label="wallet.reward.requestPoints.label.response"
            placeholder="wallet.reward.requestPoints.placeholder.response"
            name="responseMessageBox"
            onChange={setResponseMessage}
            value={responseMessage}
            rows={5}
          />
        )}
      </Spacing>
      <Flex marginTop={3} gap={1} direction="column">
        <ValidationButton primary onClick={sendRequest} load={load}>
          {status === PointsRequestStatus.StatusApproved ? (
            <FormattedMessage id="wallet.reward.pointsRequest.modal.updateStatus.approve.cta" />
          ) : status === PointsRequestStatus.StatusCancelled ? (
            <FormattedMessage id="wallet.reward.pointsRequest.modal.updateStatus.cancel.cta" />
          ) : (
            <FormattedMessage id="wallet.reward.pointsRequest.modal.updateStatus.decline.cta" />
          )}
        </ValidationButton>
        <Button onClick={onCancel}>
          <FormattedMessage id="platform.button.cancel" />
        </Button>
      </Flex>
      {error && (
        <Spacing marginTop={2}>
          <Error errorMsg={errorMsg} error={error} />
        </Spacing>
      )}
    </StyledForm>
  )
}
export default UpdateStatusRequestPointsForm
